import { useTheme } from '@emotion/react';
import { Button, CircularProgress, IconButton, MenuItem, Stack, TextField, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import { RenderIf } from '../../../../utils/customHooks';
import ErrorIcon from '@mui/icons-material/Error';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/Download';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { buttonStyle3 } from '../../../../utils/commonStyle';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ChangeStatusDialog from './ChangeStatusDialog';
import moment from 'moment';
import EditContactDialog from './EditContactDialog';

const statusList = [
  {
    countryId: '1',
    countryName: 'InProgress',
  },
  {
    countryId: '2',
    countryName: 'Approved',
  },
  {
    countryId: '3',
    countryName: 'Rejected',
  },
];

export default function VerifierDetails({ details, refresh, isLoading }) {
  const theme = useTheme();

  const [status, setStatus] = useState(null);
  const [openChangeStatus, setOpenChangeStatus] = useState(false);
  const [openEditContact, setOpenEditContact] = useState(false);

  return isLoading ? (
    <Stack
      style={{ backgroundColor: '#FFFFFF' }}
      alignItems={'center'}
      justifyContent={'center'}
    >
      <CircularProgress />
    </Stack>
  ) : (
    <Stack
      flex={1}
      style={{ backgroundColor: '#FFFFFF', height: '800px' }}
    >
       <Stack direction="row" className='p-[25px] pt-2 pb-0'>
        <Stack flex={0.6}>
          <Stack>
            <Typography
              className="fw-regular fs-12 ff-Roboto"
              color={'#14285A'}
            >
              Display Name
            </Typography>
            <Typography
              className="fw-medium fs-14 ff-Roboto !mb-[16px]"
              color={'#14285A'}
            >
              {details?.displayName || '-'}
            </Typography>
          </Stack>
        </Stack>
        <Stack flex={0.4}></Stack>
      </Stack>
      <Stack
        direction="row"
        justifyContent="space-between"
        className='p-[25px] pt-0'
      >
        <Stack flex={0.6}>
          <Stack>
            <Typography
              className="fw-regular fs-12 ff-Roboto capitalize"
              color={'#14285A'}
            >
              Verifier Name
            </Typography>
            <Typography
              className="fw-medium fs-14 ff-Roboto"
              color={'#14285A'}
            >
              {details?.verifierName || '-'}
            </Typography>
          </Stack>
          <Stack className="mt-[16px] !w-[300px]">
            <Typography
              className="fw-regular fs-12 ff-Roboto"
              color={'#14285A'}
            >
              Address
            </Typography>
            <Typography
              className="fw-medium fs-14 ff-Roboto"
              color={'#14285A'}
            >
              {details?.verifierAddress || '-'}
            </Typography>
          </Stack>
          <Stack className="mt-[16px]">
            <Typography
              className="fw-regular fs-12 ff-Roboto"
              color={'#14285A'}
            >
              Last Modified
            </Typography>
            <Typography
              className="fw-medium fs-14 ff-Roboto"
              color={'#14285A'}
            >
              {moment(new Date(details?.modifiedOn)).format('DD MMM YYYY') || '-'}
            </Typography>
          </Stack>
        </Stack>
        <Stack flex={0.4}>
          <Stack className="!w-[200px] overflow-hidden">
            <Typography
              className="fw-regular fs-12 ff-Roboto"
              color={'#14285A'}
            >
              Verifier website
            </Typography>
            <Typography
              className="fw-medium fs-14 ff-Roboto"
              color={'#14285A'}
            >
              {details?.verifierWebsite || '-'}
            </Typography>
          </Stack>
          <Stack className="mt-[16px]">
            <Typography
              className="fw-regular fs-12 ff-Roboto"
              color={'#14285A'}
            >
              Status
            </Typography>
            <Stack>
              <Button
                className="!mr-[16px] "
                sx={[buttonStyle3, { width: '85px', height: '28px' }]}
                style={{
                  backgroundColor: details?.status === '1' ? '#00A632' : '#B11B1B',
                  color: 'rgba(255, 255, 255, 1)',
                  textTransform: 'capitalize',
                }}
                onClick={() => {
                  {
                    setOpenChangeStatus(true);
                  }
                }}
                variant="contained"
                endIcon={<KeyboardArrowDownIcon />}
              >
                {details?.status === '1' ? 'Active' : 'Inactive'}
              </Button>
            </Stack>
          </Stack>
          <Stack className="mt-[16px]">
            <Typography
              className="fw-regular fs-12 ff-Roboto"
              color={'#14285A'}
            >
              State/Country
            </Typography>
            <Typography
              className="fw-medium fs-14 ff-Roboto"
              color={'#14285A'}
              style={{ textTransform: 'capitalize' }}
            >
              {details?.stateName || '-'}{', '}
              {details?.countryName || '-'}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      <Stack
        style={{ backgroundColor: theme.palette.border.main, height: '1px', marginBottom: '10px', opacity: 0.5 }}
        className="mx-[25px]"
      />

      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
        className="px-[25px]"
      >
        <Typography
          className="fw-medium fs-16 ff-Roboto"
          style={{ color: '#14285A' }}
        >
          Contact Details
        </Typography>
        <Tooltip
          disableInteractive
          title="Edit Contact"
        >
          <IconButton onClick={() => setOpenEditContact(true)}>
            <EditIcon style={{ transform: 'scale(1.143)', color: '#061D30', width: '18px', height: '18px' }} />
          </IconButton>
        </Tooltip>
      </Stack>
      <Stack
        style={{ backgroundColor: theme.palette.border.main, height: '1px', marginBottom: '10px', marginTop: '10px', opacity: 0.5 }}
        className="mx-[25px]"
      />

      {details?.contacts &&
        details?.contacts.map((item, index) => (
          <Stack>
            <Typography
              className="fw-medium fs-14 ff-Roboto"
              style={{ color: '#14285A', marginLeft: '25px', marginTop: '10px' }}
            >
              Contact Person {index + 1}
            </Typography>
            <Stack
              direction="row"
              // justifyContent="space-between"
              style={{ padding: '25px' }}
            >
              <Stack flex={0.6}>
                <Stack>
                  <Typography
                    className="fw-regular fs-12 ff-Roboto"
                    color={'#14285A'}
                  >
                    Name
                  </Typography>
                  <Typography
                    className="fw-medium fs-14 ff-Roboto"
                    color={'#14285A'}
                  >
                    {item.contactName || '-'}
                  </Typography>
                </Stack>
                <Stack className="mt-[16px] !w-[300px] overflow-hidden">
                  <Typography
                    className="fw-regular fs-12 ff-Roboto"
                    color={'#14285A'}
                  >
                    Email Id
                  </Typography>
                  <Typography
                    className="fw-medium fs-14 ff-Roboto"
                    color={'#14285A'}
                  >
                    {item.contactEmail || '-'}
                  </Typography>
                </Stack>
              </Stack>
              <Stack flex={0.4}>
                <Stack>
                  <Typography
                    className="fw-regular fs-12 ff-Roboto"
                    color={'#14285A'}
                  >
                    Designation
                  </Typography>
                  <Typography
                    className="fw-medium fs-14 ff-Roboto capitalize"
                    color={'#14285A'}
                  >
                    {item.contactDesignation || '-'}
                  </Typography>
                </Stack>
                <Stack className="mt-[16px]">
                  <Typography
                    className="fw-regular fs-12 ff-Roboto"
                    color={'#14285A'}
                  >
                    Phone No
                  </Typography>
                  <Typography
                    className="fw-medium fs-14 ff-Roboto"
                    color={'#14285A'}
                  >
                    {item.phoneCode || ''}{item.contactNumber || '-'}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack
              style={{ backgroundColor: theme.palette.border.main, height: '1px', marginBottom: '10px', opacity: 0.5 }}
              className="mx-[25px]"
            />
          </Stack>
        ))}
      {openChangeStatus ? (
        <ChangeStatusDialog
          handleClose={(event) => {
            if (event) {
              refresh();
            }
            setOpenChangeStatus(false);
          }}
          modelOpen={openChangeStatus}
          details={details}
        />
      ) : null}
      {openEditContact ? (
        <EditContactDialog
          contacts={details?.contacts}
          verifierId={details?._id}
          onModelHandleClose={(event) => {
            if (event) {
              refresh();
            }
            setOpenEditContact(false);
          }}
          modelOpen={openEditContact}
        />
      ) : null}
    </Stack>
  );
}
